var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MemberListContainer',{attrs:{"deptCode":_vm.deptCode,"comCode":_vm.comCode,"deptName":_vm.deptName,"userlang":_vm.userlang,"companyName":_vm.companyName}})
}
var staticRenderFns = []

export { render, staticRenderFns }